import * as Actions from 'actions'
import { PLAYER_TYPE } from 'enums'
import { debounce } from 'lodash'
import { MouseEvent, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isRecordingCapture, isRecordingStarted } from 'selectors/recording'
import { togglePlaybackPlaying } from 'actions/playback'
import { PlayerType } from 'types/common'
import { setActivePreview } from 'actions/preview'
import { selectorActivePreview } from 'selectors/preview'
import { useAction } from 'hooks/utils'

export const usePreviewCommon = ({ playing, playerType }:{
  playing: boolean,
  playerType: typeof PLAYER_TYPE[keyof typeof PLAYER_TYPE]
}) => {
  const mediaRecordingInProgress = useSelector(isRecordingStarted)
  const mediaRecordingInCapture = useSelector(isRecordingCapture)
  const activePreview = useSelector(selectorActivePreview)
  const stopRecordingAction = useAction(Actions.recording.stopRecording)
  const dispatch = useDispatch()
  const togglePlaying = useCallback((e: MouseEvent) => {
    e?.preventDefault()
    dispatch(togglePlaybackPlaying({ playerType }))
  }, [ dispatch, playerType ])

  const stopRecording = useCallback(() => {
    dispatch(stopRecordingAction())
  }, [ dispatch, stopRecordingAction ])

  const handleStopRecording = useCallback(() => (
    playing
      ? debounce(stopRecording, 500, { leading: true, trailing: false })
      : () => {}
  ), [ playing, stopRecording ])

  const onSelect = useCallback((playerPreview: PlayerType) => (e: MouseEvent) => {
    e.stopPropagation()
    if (activePreview !== playerPreview) {
      dispatch(setActivePreview(playerPreview))
    }
  }, [ dispatch, activePreview ])

  return {
    handleStopRecording,
    togglePlaying,
    mediaRecordingInProgress,
    mediaRecordingInCapture,
    onSelect,
  }
}
